import axios from 'axios'
import store from '@/store'
import { challengeURL, } from '@/constants/api'

export const authClient = axios.create({
  baseURL: challengeURL,
  withCredentials: true, // required to handle the CSRF token
})

/*
 * Add a response interceptor
 */
authClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (
      error.response &&
      [ 401, 403, 419, ].includes(error.response.status) &&
      store.getters['auth/authUser']
    ) {
      store.dispatch('auth/logout')
    }
    return Promise.reject(error)
  }
)

export default {
  async login (payload) {
    await authClient.get('/sanctum/csrf-cookie')
    return authClient.post('/login', payload)
  },
  async logout () {
    await authClient.get('/sanctum/csrf-cookie')
    return authClient.post('/logout', [], {
      Accept: 'application/json',
    })
  },
  async getAuthUser () {
    return await authClient.get('/users/auth')
  },
}



// WEBPACK FOOTER //
// ./src/services/AuthService.js